// utils/generatePassword.js
export const generateSecurePassword = (length = 12) => {
  if (length < 4) throw new Error("Password length must be at least 4");

  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const special = "@&";

  // First character is always uppercase
  const firstChar = uppercase[Math.floor(Math.random() * uppercase.length)];

  // Ensure at least one lowercase, one number, one special character
  const requiredChars = [
    lowercase[Math.floor(Math.random() * lowercase.length)],
    numbers[Math.floor(Math.random() * numbers.length)],
    special[Math.floor(Math.random() * special.length)],
  ];

  const allChars = lowercase + uppercase + numbers + special;

  // Fill the remaining characters
  const remainingLength = length - 1 - requiredChars.length;
  const remainingChars = Array.from({ length: remainingLength }, () => 
    allChars[Math.floor(Math.random() * allChars.length)]
  );

  // Combine required and remaining, then shuffle
  const passwordArray = [...requiredChars, ...remainingChars];

  // Shuffle except the first character
  for (let i = passwordArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
  }

  // Prepend the first uppercase letter
  return firstChar + passwordArray.join("");
};
